module.exports = __webpack_public_path__ + "img/63.8147212b.png";